import React from "react"
import Facebook from "../../svg/facebook.svg"
import Twitter from "../../svg/twitter.svg"
import Linkedin from "../../svg/linkedin.svg"
import { FooterMenu } from "./"

import styled from "styled-components"

const Brave = styled.div`
  text-transform: none;
  font-family: Georgia, serif;
  font-style: italic;
  font-size: 11px;
  font-weight: 300;
  letter-spacing: 1.2px;
  display: block;
  @media ${props => props.theme.breakpoints.large} {
    text-align: left;
  }
`
const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  span {
    width: 26px;
    display: inline-block;
    margin: 0 10px;
    svg {
      width: 100%;
      height: auto;
    }
  }
  @media ${props => props.theme.breakpoints.large} {
    justify-content: flex-start;
    span {
    }
    margin: 0 10px 0 0;
  }
`

const StyledFooter = styled.footer`
  background-color: ${props => props.theme.colors.brandColor};
  color: white;
  width: 100%;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.8;
  padding: 2rem ${props => props.theme.wrappers.standard};

  ul {
    padding: 0;
    list-style-type: none;
    li a {
      display: block;
      color: white;
      margin-bottom: 10px;
      text-decoration: none;
    }
  }

  @media ${props => props.theme.breakpoints.large} {
    .flex-row {
      display: flex;
      justify-content: space-between;
    }
    ul li {
      display: inline-block;
      a {
        margin-bottom: 0;
        margin-right: 10px;
      }
    }
  }
  @media ${props => props.theme.breakpoints.large} {
    padding: 1.5rem ${props => props.theme.wrappers.standard};
  }
`

export const Footer = () => {
  // const [menuVisible, setMenuVisible] = useState(false);
  return (
    <div>
      <StyledFooter className="">
        <SocialIcons>
          <span>
            <a
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/mytrev/"
            >
              <Facebook />
            </a>
          </span>
          <span>
            <a
              aria-label="Twitter"
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/mytrevnz"
            >
              <Twitter />
            </a>
          </span>
          <span>
            <a
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/19118334"
            >
              <Linkedin />
            </a>
          </span>
        </SocialIcons>
        <div className="flex-row">
          <FooterMenu />
          <ul>
            <li>© Trev Holdings Limited, 2019 - All Rights Reserved</li>
          </ul>
        </div>
        <Brave>
          <a
            aria-label="Brave Digital"
            href="https://bravedigital.nz/"
            target="?blank"
            rel="noopener noreferrer"
          >
            This is a brave site
          </a>
        </Brave>
      </StyledFooter>
    </div>
  )
}
